module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/full_quality.1528e3d6.svg";